import { useState, useEffect, useContext } from "react";
import { Authorization } from "../../../Context/Authorization";
import axios from "axios";
import { AuthContext } from "../../../Context/AuthContext";
import { logActivity } from "../../../utils/LogActivity";
import PreLoader from "../../../shared/PreLoaders";
import "../Vfc.css"
const inputStyle = {
  width: "100%", padding: "9px 12px", border: "1.5px solid #E2E8F0",
  borderRadius: 8, fontSize: 13, color: "#1A202C", background: "#fff",
  outline: "none", transition: "border-color 0.2s", cursor: "pointer",
};
const labelStyle = { fontSize: 12, fontWeight: 600, color: "#2D3748", marginBottom: 6, display: "flex", alignItems: "center", gap: 5 };

const RenewalFormat = () => {
  const Api = process.env.REACT_APP_API;
  const { userId, selectedJfmcType } = useContext(AuthContext);

  const [range, setRange] = useState([]);
  const [vfcData, setVfcData] = useState([]);
  const [selectedRange, setSelectedRange] = useState("");
  const [selectedVfc, setSelectedVfc] = useState("");
  const [vfcDetails, setVfcDetails] = useState(null);
  const [members, setMembers] = useState([]);
  const [showLetter, setShowLetter] = useState(false);
  const [loading, setLoading] = useState(false);
  const [noMemberMessage, setNoMemberMessage] = useState(null);

  useEffect(() => {
    const fetchRange = async () => {
      setLoading(true);
      try {
        const config = Authorization();
        const response = await axios.get(`${Api}/api/ranges`, config);
        setRange(response.data);
      } catch (err) {
        console.error("Error fetching ranges", err);
      } finally {
        setLoading(false);
      }
    };
    fetchRange();
  }, [Api]);

  const handleRangeChange = async (e) => {
    const rangeId = e.target.value;
    setSelectedRange(rangeId);
    setSelectedVfc("");
    setVfcDetails(null);
    setShowLetter(false);
    if (!rangeId) return;
    setLoading(true);
    try {
      const config = Authorization();
      const response = await axios.post(
        `${Api}/api/vfcs/vfcs-by-range`,
        { rangeId, jfmcTypeId: selectedJfmcType?._id },
        config
      );
      setVfcData(response.data.vfcs);
    } catch (err) {
      console.error("Error fetching VFCs by range", err);
    } finally {
      setLoading(false);
    }
  };

  const handleVfcChange = async (e) => {
    const vfcId = e.target.value;
    setSelectedVfc(vfcId);
    setShowLetter(false);
    setNoMemberMessage(null);
    setMembers([]);
    if (!vfcId) return;
    setLoading(true);
    try {
      const config = Authorization();
      const vfcRes = await axios.get(`${Api}/api/vfcs/${vfcId}`, config);
      setVfcDetails(vfcRes.data.vfc);
      try {
        const designationRes = await axios.post(
          `${Api}/api/member/designation/all-designations`,
          { vfcId },
          config
        );
        if (Array.isArray(designationRes.data) && designationRes.data.length > 0) {
          setMembers(designationRes.data);
          setNoMemberMessage(null);
        } else if (designationRes.data?.message) {
          setMembers([]);
          setNoMemberMessage(designationRes.data.message);
        } else {
          setMembers([]);
          setNoMemberMessage("No member data found.");
        }
      } catch (innerErr) {
        if (innerErr.response?.data?.message) {
          setMembers([]);
          setNoMemberMessage(innerErr.response.data.message);
        } else {
          setNoMemberMessage("Failed to load member details. Please try again.");
        }
      }
      await logActivity(userId, "Viewed VFC for Renewal", "RenewalFormat Page", Api);
    } catch (err) {
      console.error("Error fetching VFC/member info", err);
      setVfcDetails(null);
      setNoMemberMessage("Error fetching VFC details.");
    } finally {
      setLoading(false);
    }
  };

  const handleLoadLetter = () => setShowLetter(true);

  const handlePrint = () => {
    const printContent = document.getElementById("content-to-print");
    const originalContent = document.body.innerHTML;
    document.body.innerHTML = printContent.outerHTML;
    window.print();
    document.body.innerHTML = originalContent;
  };

  const currentYear = new Date().getFullYear();
  const financialYear = `${currentYear}-${currentYear + 1}`;

  /* ════════════════════════════════════════════
     RENDER
  ════════════════════════════════════════════ */
  return (
    <div>
      {loading && <PreLoader loading={loading} />}

      {/* ── Page Header ── */}
      <div style={{ marginBottom: 20 }}>
        <h4 style={{ margin: 0, fontWeight: 700, color: "#1A202C", fontSize: 18 }}>Renewal Letter</h4>
        <div style={{ fontSize: 12, color: "#718096", marginTop: 3 }}>
          <span style={{ color: "#A0AEC0" }}>JFMC</span>
          <span style={{ margin: "0 6px", color: "#CBD5E0" }}>›</span>
          <span style={{ color: "#2E7D32", fontWeight: 600 }}>Renewal Letter</span>
        </div>
      </div>

      {/* ── No JFMC type selected ── */}
      {!selectedJfmcType ? (
        <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #FED7D7", padding: "48px 24px", textAlign: "center" }}>
          <div style={{ width: 60, height: 60, background: "#FFF5F5", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 14px" }}>
            <i className="mdi mdi-tag-outline" style={{ fontSize: 28, color: "#E53E3E" }} />
          </div>
          <div style={{ fontSize: 14, fontWeight: 700, color: "#2D3748", marginBottom: 6 }}>JFMC Type not selected</div>
          <div style={{ fontSize: 12, color: "#A0AEC0" }}>Use the <strong>JFMC Type</strong> selector in the top navigation bar</div>
        </div>
      ) : (
        <>
          {/* ── Filter Card ── */}
          <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", padding: "20px 24px", marginBottom: 20 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
              <span style={{ width: 30, height: 30, background: "linear-gradient(135deg,#1B5E20,#43A047)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 14 }}>
                <i className="mdi mdi-filter-variant" />
              </span>
              <span style={{ fontSize: 13, fontWeight: 700, color: "#1A202C" }}>Filter</span>
              <span style={{ fontSize: 11, color: "#A0AEC0", marginLeft: 4 }}>Select range and JFMC to generate renewal letter</span>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0,1fr))", gap: 16 }}>
              <div>
                <label style={labelStyle}><i className="mdi mdi-map-marker-outline" style={{ color: "#43A047" }} /> Range</label>
                <select
                  value={selectedRange}
                  onChange={handleRangeChange}
                  disabled={loading}
                  style={inputStyle}
                  onFocus={(e) => e.target.style.borderColor = "#4CAF50"}
                  onBlur={(e) => e.target.style.borderColor = "#E2E8F0"}
                >
                  <option value="">— Select Range —</option>
                  {range.map((r) => (
                    <option key={r._id} value={r._id}>{r.rangeName}</option>
                  ))}
                </select>
              </div>

              <div>
                <label style={{ ...labelStyle, color: selectedRange ? "#2D3748" : "#A0AEC0" }}>
                  <i className="mdi mdi-home-group" style={{ color: selectedRange ? "#43A047" : "#CBD5E0" }} /> JFMC Name
                </label>
                <select
                  value={selectedVfc}
                  onChange={handleVfcChange}
                  disabled={loading || !selectedRange}
                  style={{ ...inputStyle, color: selectedRange ? "#1A202C" : "#A0AEC0", background: selectedRange ? "#fff" : "#F7FAFC", cursor: selectedRange ? "pointer" : "not-allowed" }}
                  onFocus={(e) => e.target.style.borderColor = "#4CAF50"}
                  onBlur={(e) => e.target.style.borderColor = "#E2E8F0"}
                >
                  <option value="">— Select JFMC —</option>
                  {vfcData.map((vfc) => (
                    <option key={vfc._id} value={vfc._id}>{vfc.vfcName}</option>
                  ))}
                </select>
              </div>
            </div>

            {/* Load Letter Button */}
            {vfcDetails && !showLetter && !loading && (
              <div style={{ marginTop: 16 }}>
                <button
                  onClick={handleLoadLetter}
                  style={{ display: "inline-flex", alignItems: "center", gap: 8, padding: "10px 20px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)", color: "#fff", border: "none", borderRadius: 9, fontSize: 13, fontWeight: 700, cursor: "pointer", boxShadow: "0 3px 10px rgba(46,125,50,0.3)" }}
                >
                  <i className="mdi mdi-file-document-outline" />
                  Load Renewal Letter
                </button>
              </div>
            )}
          </div>

          {/* ── Letter Content Card ── */}
          {showLetter && vfcDetails && (
            <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", boxShadow: "0 1px 4px rgba(0,0,0,0.07)", overflow: "hidden" }}>
              {/* Card header */}
              <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)" }}>
                <span style={{ width: 30, height: 30, background: "rgba(255,255,255,0.15)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 15 }}>
                  <i className="mdi mdi-file-document-outline" />
                </span>
                <span style={{ fontSize: 13, fontWeight: 700, color: "#fff", flex: 1 }}>வனக்குழு புதுப்பிப்பு படிவம்</span>
                <div className="no-print" style={{ display: "flex", gap: 8 }}>
                  <button
                    onClick={handlePrint}
                    style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "6px 14px", background: "rgba(255,255,255,0.2)", color: "#fff", border: "1px solid rgba(255,255,255,0.3)", borderRadius: 7, fontSize: 12, fontWeight: 600, cursor: "pointer" }}
                  >
                    <i className="mdi mdi-printer" /> Print
                  </button>
                  <button
                    onClick={() => setShowLetter(false)}
                    style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "6px 14px", background: "rgba(255,255,255,0.1)", color: "#fff", border: "1px solid rgba(255,255,255,0.2)", borderRadius: 7, fontSize: 12, fontWeight: 600, cursor: "pointer" }}
                  >
                    <i className="mdi mdi-eye-off-outline" /> Hide
                  </button>
                </div>
              </div>

              {/* Letter body */}
              <div id="content-to-print" style={{ padding: "24px" }}>

                {/* Page 1: Request Letter */}
                <div className="print-section portrait" style={{ marginBottom: 24, padding: 16, border: "1px solid #E2E8F0", borderRadius: 8 }}>
                  <span className="bamini-text"><strong>mDg;Gdu;</strong></span>
                  <p className="ml-5 bamini-text">nrayhsu;</p>
                  <p className="ml-5">{vfcDetails.vfcName}, வனக்குழு</p>
                  <p className="ml-5">{vfcDetails.village}</p>
                  <p className="ml-5">{vfcDetails.address}</p>
                  <p className="ml-5">{vfcDetails.panchayath}</p>
                  <p className="ml-5">{vfcDetails.thaluk}</p>
                  <p className="ml-5">{vfcDetails.pinCode}</p>

                  <span className="bamini-text"><strong>ngWeu;</strong></span>
                  <p className="ml-5 bamini-text">cau;jpU khtl;l gjpthsu; mtu;fs;</p>
                  <p className="ml-5 bamini-text">khtl;l gjpthsu; mYtyfk;</p>

                  <br />
                  <span className="bamini-text">mk;kh</span> / <span className="bamini-text">Iah</span>
                  <br />
                  <p>
                    <span className="bamini-text ml-4">nghUs;</span>:
                    <span className="bamini-text">
                      {""} <strong>gjpT vz;</strong>
                    </span>
                    : {vfcDetails.registrationNo} - Village Forest Council,{" "}
                    {vfcDetails.vfcName}, {financialYear}
                    <span className="bamini-text">
                      -k; Mz;bw;fhd tuT nryT fzf;F Mbl;lu; mwpf;if kw;Wk;
                      tUlhe;jpu mwpf;iffs; fPo;fz;lthW jq;fs; mYtyfj;jpy;
                      gjpTf;F jhf;fy; nra;fpNwhk;. Nfhu;it nra;jpLkhW kpfTk;
                      jho;ikAld; Ntz;LfpNwhk;. ,jw;Fupa fl;lzk; ,j;Jld;
                      nrYj;JfpNwhk;
                    </span>
                  </p>
                  <span className="bamini-text">,izg;G</span>
                  <ol>
                    <li className="bamini-text">cWjpnkhop</li>
                    <li className="bamini-text">gbtk;</li>
                    <li className="bamini-text">{financialYear} -k; Mz;bd; tuT nryT Mbl;lu; mwpf;if</li>
                    <li className="bamini-text">nghJf;FO jPu;khd efy;</li>
                  </ol>
                </div>

                <div className="page-break" />

                {/* Page 2: EC Member Table */}
                <div className="print-section" style={{ marginBottom: 24, border: "1px solid #E2E8F0", borderRadius: 8, overflow: "hidden" }}>
                  <div style={{ padding: "10px 16px", background: "#F7FAFC", borderBottom: "1px solid #EDF2F7" }}>
                    <span style={{ fontSize: 14, fontWeight: 700, color: "#1A202C" }}>FORM-VI: EC Member List</span>
                  </div>
                  {noMemberMessage ? (
                    <div style={{ padding: "24px", textAlign: "center", color: "#C62828", fontWeight: 600, fontSize: 13 }}>{noMemberMessage}</div>
                  ) : (
                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                      <thead>
                        <tr>
                          {["#", "Name", "Designation"].map((h) => (
                            <th key={h} style={{ padding: "10px 16px", textAlign: "left", fontWeight: 600, fontSize: 12, color: "#4A5568", borderBottom: "1px solid #EDF2F7", background: "#F7FAFC" }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {members.map((m, i) => (
                          <tr key={m._id} style={{ borderBottom: "1px solid #EDF2F7" }}>
                            <td style={{ padding: "10px 16px", color: "#718096" }}>{i + 1}</td>
                            <td style={{ padding: "10px 16px", color: "#1A202C", fontWeight: 600 }}>{m.name}</td>
                            <td style={{ padding: "10px 16px", color: "#4A5568" }}>{m.designation}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>

                <div className="page-break" />

                {/* Page 3: Signature */}
                <div className="print-section portrait" style={{ padding: 16, border: "1px solid #E2E8F0", borderRadius: 8, textAlign: "center" }}>
                  <p>Village Forest Council, {vfcDetails.vfcName}</p>
                  <p>{vfcDetails.village}</p>
                  <p>{vfcDetails.address}</p>
                  <p>{vfcDetails.panchayath}</p>
                  <p>{vfcDetails.thaluk}</p>
                  <p>{vfcDetails.pinCode}</p>
                  <p>{vfcDetails.registrationNo}</p>
                  <h4 className="bamini-text"><strong>cWjpnkhop</strong></h4>
                  <p>
                    Village Forest Council, {vfcDetails.vfcName}
                    <span className="bamini-text">
                      {" "}vd;w vq;fsJ rq;fk; fle;j 2024-2025-k; Mz;by; ey;yKiwapy;
                      nray;gl;L te;Js;sJ vd;Wk; mNjNghy; elg;G Mz;bYk; vq;fsJ
                      rq;fk; ey;y Kiwapy; ,aq;fp tUfpwJ vd;Wk; ,jd; %yk; cWjp
                      $WfpNwd;
                    </span>
                  </p>
                </div>

              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default RenewalFormat;
